import BlogList from './BlogList';
import BlogDetail from './BlogDetail';

const path = '/blog';

export const publicBlogRoutes = [
  {
    name: 'Blog List',
    path: `${path}`,
    icon: 'newspaper',
    component: BlogList,
    exact: true,
  },
  {
    name: 'Blog Detail',
    path: `${path}/:slug`,
    icon: 'newspaper',
    component: BlogDetail,
    exact: true,
  },
];

export const publicRedirects = [
  {
    from: `${path}`,
    to: `${path}`,
  },
];

export default publicBlogRoutes;